import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-journey-card-flix',
  templateUrl: 'journey-card-flix.component.html'
})
export class JourneyCardFlixComponent {
    @Input() setting: any;
    @Input() item: any;
}
